<script setup>
import { useRouter } from 'vue-router';
import SportLiveTvResults from '@/sport-live-tv/components/sport-live-tv-results.vue';
import SportLiveTvRows from '@/sport-live-tv/components/sport-live-tv-rows.vue';
import { getSportLiveTvWatchRoute } from '@/sport-live-tv/helpers';

defineProps({
  isFiltered: { type: Boolean, default: false },
  selectionEvents: { type: Object, required: true },
  featured: { type: Array, required: true },
  live: { type: Array, required: true },
  categories: { type: Array, required: true },
  scoresVisible: { type: Boolean, default: false },
});

const emit = defineEmits(['clear-filters', 'select-category', 'show-live']);

const router = useRouter();

const openEvent = (event) => router.push(getSportLiveTvWatchRoute(event));
</script>

<template>
  <SportLiveTvResults
    v-if="isFiltered"
    :events="selectionEvents.events"
    :is-loading="selectionEvents.isLoading"
    :is-error="selectionEvents.isError"
    :has-next-page="selectionEvents.hasNextPage"
    :is-fetching-next-page="selectionEvents.isFetchingNextPage"
    :scores-visible="scoresVisible"
    @select="openEvent"
    @clear-filters="emit('clear-filters')"
    @fetch-next-page="selectionEvents.fetchNextPage"
    @retry="selectionEvents.reload"
  />
  <SportLiveTvRows
    v-else
    :featured="featured"
    :live="live"
    :categories="categories"
    :scores-visible="scoresVisible"
    @select="openEvent"
    @select-category="emit('select-category', $event)"
    @show-live="emit('show-live')"
  />
</template>
